import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Barcode from "react-barcode-generator";

interface BarcodeDisplayProps {
  code: string;
  title?: string;
  height?: number;
  width?: number;
  fontSize?: number;
  displayValue?: boolean;
}

const BarcodeDisplay: React.FC<BarcodeDisplayProps> = ({
  code,
  title = "Redemption Code",
  height = 60,
  width = 2,
  fontSize = 14,
  displayValue = true,
}) => {
  if (!code) {
    return (
      <Paper
        elevation={2}
        sx={{
          p: 3,
          textAlign: "center",
          backgroundColor: "#f5f5f5",
          border: "2px dashed #ccc",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No code available
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        textAlign: "center",
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ mb: 2, fontWeight: 600 }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#ffffff",
          p: 2,
          borderRadius: 1,
          border: "1px solid #f0f0f0",
        }}
      >
        <Barcode
          value={code}
          format="CODE128"
          width={width}
          height={height}
          fontSize={fontSize}
          displayValue={displayValue}
          textAlign="center"
          textPosition="bottom"
          background="#ffffff"
          lineColor="#000000"
        />
      </Box>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 1, display: "block" }}
      >
        Present this barcode for redemption
      </Typography>
    </Paper>
  );
};

export default BarcodeDisplay;
